export default __webpack_public_path__ + "static/media/Mystic's Armbands of the Soaring Heart.1232099f.jpg";